var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row no-gutters", attrs: { id: "modal-header" } },
    [
      _c("div", { staticClass: "col" }, [
        _c(
          "p",
          {
            staticClass: "modal-title",
            style: _vm.titleStyle,
            attrs: {
              lang: _vm.narratorLang,
              tabindex: "-1",
              "aria-label": _vm.$t(_vm.titleText)
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.$t(_vm.titleText)) + "\n    ")]
        )
      ]),
      _vm._v(" "),
      _vm.hasSeparator
        ? _c("div", { staticClass: "col-12 pt-4" }, [
            _c("hr", { staticClass: "line" })
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/shared/elements/modal/ModalHeader.vue?vue&type=template&id=7ee0c70a&scoped=true&
// module id = null
// module chunks = 